import { createRequestException } from '@/helpers/requestException'
import { JurosBaixosSystemsAPI } from '@/helpers/axios/jurosbaixos-systems'

export const selectNoCollateralOffer = async ({ selectPayload, offerId }) => {
  return await JurosBaixosSystemsAPI.post(
    `loans/no-collateral/offers/${offerId}/select`,
    selectPayload || {},
  ).catch(createRequestException)
}
